/*
  File name: deadline.js
    Program Description:
    - This file uses the baseUrl method and the specified functions inside the
    rest file in order to send requests from the web application to the server.
    - This file is focused on the requests related to the PDBNF feature
*/

import { baseUrl } from '@/settings'
import { patch, get } from '@/utils/rest'

const master = {
  evaluate: (_id, body) => patch(`${baseUrl}/evaluate/pdbnf/${_id}`, body),
  review: (_id, body) => patch(`${baseUrl}/review/pdbnf/${_id}`, body),
  statusChange: (_id, collection, body) => patch(`${baseUrl}/assign/${collection}/statusUpdate/${_id}`, body),
  viewSettings: () => get(`${baseUrl}/settings/days`),
  patchSettings: (body) => patch(`${baseUrl}/settings/days`, body),
  setDeadline: (_id, body) => patch(`${baseUrl}/updateDeadline/${_id}`, body)
}
export default master
